/**
 * Language Order Controller
 * Reorders language dropdown items in the preferred order
 * and fixes currency display issues
 */
document.addEventListener('DOMContentLoaded', function() {
  // Wait for the language selector to load
  setTimeout(function() {
    // Define your preferred language order
    const preferredOrder = [
      'en', // English
      'fr', // French
    ];
    
    // Function to reorder the language list
    function reorderLanguages() {
      const languageList = document.querySelector('.lsn-select__list');
      
      if (!languageList) return;
      
      // Get all language items
      const languageItems = Array.from(languageList.querySelectorAll('.lsn-select__item'));
      
      // Sort language items based on preferred order
      languageItems.sort(function(a, b) {
        const aCode = a.getAttribute('data-value');
        const bCode = b.getAttribute('data-value');
        
        return preferredOrder.indexOf(aCode) - preferredOrder.indexOf(bCode);
      });
      
      // Remove all items first
      languageItems.forEach(item => item.remove());
      
      // Append items in the new order
      languageItems.forEach(item => languageList.appendChild(item));
      
      console.log('Languages reordered successfully');
    }
    
    // Fix currency display issues
    function fixCurrencyDisplay() {
      // Fix currency selectors to ensure text is displayed next to flags
      const currencyElements = document.querySelectorAll(
        '.lsn-currency-switcher .lsn-current,\n        .lsn-currency-switcher .lsn-select__button,\n        .lsn-currency-switcher .lsn-select__item,\n        .hdt-currencies button'
      );
      
      currencyElements.forEach(function(element) {
        // Force display as flex to show both flag and text
        element.style.display = 'flex';
        element.style.flexDirection = 'row';
        element.style.alignItems = 'center';
        element.style.gap = '6px';
        
        // Find currency text elements and ensure they're visible
        const textElements = element.querySelectorAll(
          '.lsn-current__code, .lsn-current__title,\n          .lsn-select__button-code, .lsn-select__button-title,\n          .lsn-select__item-code, .lsn-select__item-name,\n          [data-name-current]'
        );
        
        textElements.forEach(function(textEl) {
          textEl.style.display = 'inline-block';
          textEl.style.visibility = 'visible';
          textEl.style.opacity = '1';
          textEl.style.width = 'auto';
          textEl.style.minWidth = '24px';
        });
      });
    }
    
    // Initial fixes
    reorderLanguages();
    fixCurrencyDisplay();
    
    // Watch for changes (if the language list is loaded dynamically)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length) {
          // Check if language dropdown was added
          mutation.addedNodes.forEach(function(node) {
            if (node.classList && node.classList.contains('lsn-select__list')) {
              reorderLanguages();
              fixCurrencyDisplay();
            }
          });
        }
      });
    });
    
    // Start observing the document body
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Also handle the dropdown when it's opened
    document.addEventListener('click', function(event) {
      if (event.target.closest('.lsn-switcher') || event.target.closest('.lsn-language-switcher')) {
        setTimeout(reorderLanguages, 100);
        setTimeout(fixCurrencyDisplay, 100);
      }
    });
    
    // Run currency fix periodically to ensure it always works
    setInterval(fixCurrencyDisplay, 3000);
    
    // Add improved styling for language and currency selectors
    const style = document.createElement('style');
    style.textContent = `
      .lsn-select__list {
        display: flex;
        flex-direction: column;
        max-height: 350px;
        overflow-y: auto;
        backdrop-filter: blur(10px);
        -webkit-backdrop-filter: blur(10px);
        background-color: rgba(255, 255, 255, 0.4) !important;
        border-radius: 6px !important;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1) !important;
        padding: 6px !important;
        margin-right: 4px !important;
      }
      
      /* Ensure currency text is visible */
      .lsn-current__code, 
      .lsn-current__title,
      .lsn-select__button-code, 
      .lsn-select__button-title,
      .lsn-select__item-code, 
      .lsn-select__item-name,
      [data-name-current] {
        display: inline-block !important;
        visibility: visible !important;
        opacity: 1 !important;
        width: auto !important;
        min-width: 24px !important;
      }
      
      .lsn-select__item {
        display: flex;
        align-items: center;
        padding: 6px 8px !important;
        border-radius: 4px !important;
        transition: background-color 0.2s ease;
      }
      
      .lsn-select__item:hover {
        background-color: rgba(0, 0, 0, 0.05) !important;
      }
      
      .lsn-select__item-icon {
        width: 12px !important;
        height: 10px !important;
        margin-right: 4px !important;
        border-radius: 2px !important;
      }
      
      .lsn-select__item-name {
        text-transform: uppercase;
        font-size: 12px !important;
        font-weight: 500 !important;
        flex: 1;
        text-align: left;
      }
      
      .lsn-select__item .lsn-select__arrow {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
    
  }, 1000); // Wait 1 second for initial load
});